module.exports = __webpack_public_path__ + "img/user.c8d0a71c.png";